module.exports = __webpack_public_path__ + "img/defaultAvatar.55af3318.svg";